// extracted by mini-css-extract-plugin
export default {"select":"SuperSelect_select__LAv4j","option":"SuperSelect_option__JRlYO"};